import React from 'react';
import PropTypes from 'prop-types';

import MobileTaskForm from 'components/tasks/mobile_task_form';
import taskPropTypes from 'components/tasks/prop_types';
import { addTask, updateTask, removeTask } from 'components/tasks/api';
import { moveScrollToTop } from 'helpers/scrolling';
import { enableTab } from  'helpers/dom_helper';

import 'bundles/tasks/index/tasks.scss';

class MobileActivityFormWrapper extends React.Component {
  static propTypes = {
    activity: taskPropTypes,
    callListsAccess: PropTypes.bool.isRequired,
    currentDatabaseId: PropTypes.number,
    currentUserId: PropTypes.number.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    defaultAssociatedModels: PropTypes.array,
    hideByProjectSelect: PropTypes.bool,
    hideContactSelect: PropTypes.bool,
    hideProjectSelect: PropTypes.bool,
    hidePropertySelect: PropTypes.bool
  };

  state = {
    errors: null
  };

  handleSave = async (task) => {
    try {
      if (!this.props.activity) {
        await addTask(task);
      } else {
        await updateTask(task);
      }
      this.updateView();
    } catch (err) {
      this.setState({ errors: err });
    }
  }

  handleDelete = async (task) => {
    if (!this.props.activity || !task) return;
    try {
      await removeTask(task);
    } catch (err) {
      this.setState({ errors: err });
    }
    this.updateView();
  }

  handleCancel = () => {
    this.setState({ errors: null });
    enableTab('task-list', ['js-mobile-tabs', 'js-mobile-page-header', 'mobile-page-header']);
  }

  updateView = () => {
    moveScrollToTop();
    window.location.reload();
  }

  render() {
    const {
      activity,
      callListsAccess,
      currentDatabaseId,
      currentUserId,
      defaultAssociatedModels,
      databaseMembers,
      hideByProjectSelect,
      hideContactSelect,
      hideProjectSelect,
      hidePropertySelect
    } = this.props;
    const onDelete = activity ? this.handleDelete : undefined;

    return (
      <div className="tasks-mobile-content">
        <MobileTaskForm
          assigneeOptions={databaseMembers}
          callListsAccess={callListsAccess}
          currentDatabaseId={currentDatabaseId}
          defaultAssociatedModels={defaultAssociatedModels}
          defaultTaskAssignee={databaseMembers.find(member => member.id === currentUserId)}
          errors={this.state.errors}
          existingTask={activity}
          hideByProjectSelect={hideByProjectSelect}
          hideContactSelect={hideContactSelect}
          hideProjectSelect={hideProjectSelect}
          hidePropertySelect={hidePropertySelect}
          indexView={true}
          isActivity={true}
          multipleProjects={true}
          onCancel={this.handleCancel}
          onDelete={onDelete}
          onSave={this.handleSave}
        />
      </div>
    );
  }
}

export default MobileActivityFormWrapper;
